import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GatesService {
    token = localStorage.getItem('token');

    constructor(private http: HttpClient) { }

    private _gatesData = new BehaviorSubject<boolean>(false);
    gatesData = this._gatesData.asObservable();

    setGatesReload() {
        this._gatesData.next(true);
    }

    getGatesReload() {
        return this._gatesData;
    }

    private _gateData = new BehaviorSubject<Object>(null);
    gateData = this._gateData.asObservable();

    setGateData(gate) {
        this._gateData.next(gate);
    }

    getGateData() {
        return this._gateData;
    }

    getAllGates() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates`)
    }

    getGate(gateId) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates/${gateId}`);
    }

    addGate(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates`, body);
    }

    updateGate(body, gateId) {
        return this.http.put(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates/${gateId}`, body);
    }

    deleteGate(gateId) {
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates/${gateId}`);
    }

    assignGuardsToGate(body, gateId) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates/${gateId}/users`, body)
    }

    getSecurity() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?role_type=staff&is_paginated=0&filter[role][]=security&filter[role][]=shared_gate_scanner`)
    }
}